<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove {{hokp.ktpttaal_oms}} from rental contract {{hokp.huov_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmHokp">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hokp_encrid: null,
      hokp: {}
    }
  },
  methods: {
    open(hokp_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/hokp/getHokp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHokp"
          },
          getHokp: {
            hokp_encrid: hokp_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hokp = res.data.getHokp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHokp() { 
      this.$axios
        .post("ares/json/ares/huov/hokp/rmHokp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHokp"
          },
          rmHokp: {
            hokp_encrid: this.hokp.hokp_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/huov/onHuov/' + res.data.rmHokp.huov_encrid); 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHokp.text,
              color: res.data.rmHokp.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

